import { useEffect, useState, useCallback } from "react"
import Table from "../../molecules/tablas/view"
import { listener } from "../../../utils/dispatch"
import { getNoteDocuments } from "../../../usecases/notes-usecase"
import { EmptyArray } from "../../../app/domain/models/empty/empty"
import ListItemsNote from "../listItemsNote/view"

const ListNotes = ({ profile }) => {
    const [notesData, setNotesData] = useState({
        data: undefined,
        total: 0,
        page: 1,
        page_size: 10
    });
    const [isLoading, setIsLoading] = useState(true);

    const update = useCallback((page = notesData.page, limit = notesData.page_size) => {
        setIsLoading(true);
        getNoteDocuments(profile.uid, profile.cid, page, limit)
            .then((res) => {
                setNotesData({
                    data: res?.data || EmptyArray,
                    total: res?.total || 0,
                    page: res?.page || page,
                    page_size: res?.page_size || limit
                });
            })
            .catch(() => {
                setNotesData(prev => ({ ...prev, data: EmptyArray }));
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [profile, notesData.page, notesData.page_size]);

    useEffect(() => {
        update();
        const cleanReload = listener('update-notes', () => update());
        return () => cleanReload();
    }, [update]);

    const notesMapped = (data) => {
        if (!data || (data.length > 0 && data[0]['message'] === 'empty_array')) return EmptyArray;
        return data.map(item => ({
            created_at: item.created_at,
            note_id: item.note_id,
            total_items: item.total_items,
            description: item.description,
            total_amount: item.total_amount // Kept but maybe excluded in Table
        }));
    };

    return (
        <Table
            id="notes-table"
            isLoading={isLoading}
            paginatedData={{ ...notesData, data: notesMapped(notesData.data) }}
            getFunction={update}
            emptyChild={<>No tienes notas de ajuste registradas</>}
            headersList={["Fecha", "ID Nota", "Nº Ítems", "Descripción"]}
            excludeList={["total_amount"]}
            onReload={update}
            allowPageSizeControl={true}
            formats={{
                created_at: { type: "timestamp" }
            }}
        >
            <ListItemsNote profile={profile} />
        </Table>
    )
}

export default ListNotes
